<template>
  <div id="app">
    <div class="wrapper">
      <menu-lateral-principal :active-sidebar="activeSidebar" v-if="showHeader" />

      <div class="content-container" :class="{ active: activeSidebar }">
        <b-navbar class="nav-top" type="" toggleable v-if="showHeader">
          <div class="container-fluid">
            <button type="button" class="btn btn-sidebar-collapse" @click="sidebarCollapse()">
              <i class="fas fa-bars"></i>
            </button>

            <ul class="nav">
              <li class="nav-item" data-placement="bottom" v-b-tooltip.hover title="Notificações" v-if="false">
                <div class="dropdown notif-menu">
                  <a class="nav-link" href="#"
                     data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fas fa-bell"></i><i
                    class="fas fa-circle"></i></a>
                  <div class="dropdown-menu dropdown-menu-right"
                       aria-labelledby="dropdownMenuButton">
                    <p>Notificações</p>

                    <notificacoes />
                  </div>
                </div>
              </li>
        <div class="dropdown show">
          <i class="mdi mdi-cog" href="#" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" title="Opções"></i>

          <div class="dropdown-menu dropdown-menu-right mt-2" aria-labelledby="dropdownMenuLink" @click="mudarEmpresa">
            <a class="dropdown-item" title="Mudar Empresa" href="javascript:void(0)">
              <i class="mdi mdi-refresh text-dark"></i> Mudar Empresa
            </a>
            <a class="dropdown-item" title="Sair" href="javascript:void(0)" @click="logout">
              <i class="mdi mdi-exit-to-app text-dark"></i> Sair
            </a>
          </div>
          </div>
            </ul>
          </div>
        </b-navbar>

        <main>
          <router-view></router-view>
        </main>

        <app-footer v-if="showFooter" />
      </div>
    </div>
  </div>
</template>

<script>
import MenuLateralPrincipal from '@/components/template/MenuLateralPrincipal'
import Notificacoes from '@/components/notificacoes/Notificacoes'
import 'bootstrap/js/dist/dropdown'
import AppFooter from '@/components/template/AppFooter'
import LoginUtils from '@/core/util/login-utils'

export default {
  name: 'app',
  components: { AppFooter, Notificacoes, MenuLateralPrincipal },
  data () {
    return {
      activeSidebar: false,
      showHeader: false,
      showFooter: false
    }
  },
  mounted () {
    this.verificarExibicaoHeaderFooter()
  },

  updated () {
    this.verificarExibicaoHeaderFooter()
  },

  methods: {
    verificarExibicaoHeaderFooter: function () {
      const ignoredRoutesHeaderFooter = ['not-found', 'release-notes', 'login', 'empresa']

      this.showHeader = !ignoredRoutesHeaderFooter.includes(this.$route.name)
      this.showFooter = !ignoredRoutesHeaderFooter.includes(this.$route.name)

      if (!this.showHeader) {
        this.activeSidebar = true
      }
    },

    sidebarCollapse: function () {
      this.activeSidebar = !this.activeSidebar
    },

    logout: function () {
      LoginUtils.logout()

      window.location = '/login'
    },
    mudarEmpresa () {
      this.$router.push('/empresa')
    }
  }
}
</script>

<style>
</style>
